export default __webpack_public_path__ + "static/media/close_icon.118074ba.svg";